import {profile} from "../../variables";

export const save_profile_in_local_storage = () => {localStorage.setItem('profile', JSON.stringify(profile));};
export const get_profile_from_local_storage = () => {try{return JSON.parse(localStorage.getItem('profile'))}catch(e){}};
export const remove_profile_from_local_storage = () => {try{localStorage.removeItem('profile')}catch(e){}};

export const set_default_profile = () => {for (let key in profile) {profile[key] = null}};
export const update_profile = data => {for (let key in data) {profile[key] = data[key]}};